import { Grid, Typography } from "@mui/material";
import IRatingAnalytics from "../../interface/iRatingAnalytics";
import { RatingOverviewContext } from "../../context/ratingOverviewContext";
import React from "react";

const RenderCategorySummery = (): React.JSX.Element => {
  const {
    ratingAnalytics,
  }: {
    ratingAnalytics: IRatingAnalytics;
  } = React.useContext(RatingOverviewContext);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <Typography
          variant="caption"
          color="initial"
          sx={{
            fontWeight: "bold",
          }}
        >
          Summe aller {ratingAnalytics.total.ratings} Bewertungen
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={1}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
        }}
      >
        {ratingAnalytics.total.all1Stars}
      </Grid>
      <Grid
        item
        xs={12}
        sm={1}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
        }}
      >
        {ratingAnalytics.total.all2Stars}
      </Grid>
      <Grid
        item
        xs={12}
        sm={1}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
        }}
      >
        {ratingAnalytics.total.all3Stars}
      </Grid>
      <Grid
        item
        xs={12}
        sm={1}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
        }}
      >
        {ratingAnalytics.total.all4Stars}
      </Grid>
      <Grid
        item
        xs={12}
        sm={1}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
        }}
      >
        {ratingAnalytics.total.all5Stars}
      </Grid>

      <Grid
        item
        xs={12}
        sm={1}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
        }}
      >
        {ratingAnalytics.total.average}
      </Grid>
    </Grid>
  );
};

export default RenderCategorySummery;
